var map = {
	"./alertIcon.svg": "./src/assets/icons/alertIcon.svg",
	"./allergyIcon.svg": "./src/assets/icons/allergyIcon.svg",
	"./analytics1.svg": "./src/assets/icons/analytics1.svg",
	"./analytics2.svg": "./src/assets/icons/analytics2.svg",
	"./arrowDecreasingIcon.svg": "./src/assets/icons/arrowDecreasingIcon.svg",
	"./arrowDownIcon.svg": "./src/assets/icons/arrowDownIcon.svg",
	"./arrowIcon.svg": "./src/assets/icons/arrowIcon.svg",
	"./arrowIncreasingIcon.svg": "./src/assets/icons/arrowIncreasingIcon.svg",
	"./arrowLeftIcon.svg": "./src/assets/icons/arrowLeftIcon.svg",
	"./arrowRightIcon.svg": "./src/assets/icons/arrowRightIcon.svg",
	"./bacteriumIcon.svg": "./src/assets/icons/bacteriumIcon.svg",
	"./badgeCheckIcon.svg": "./src/assets/icons/badgeCheckIcon.svg",
	"./badgeExclamationIcon.svg": "./src/assets/icons/badgeExclamationIcon.svg",
	"./barChartIconMultiColor.svg": "./src/assets/icons/barChartIconMultiColor.svg",
	"./bedIcon.svg": "./src/assets/icons/bedIcon.svg",
	"./bellIcon.svg": "./src/assets/icons/bellIcon.svg",
	"./bellIconHalfColor.svg": "./src/assets/icons/bellIconHalfColor.svg",
	"./bellSlashIcon.svg": "./src/assets/icons/bellSlashIcon.svg",
	"./boltIcon.svg": "./src/assets/icons/boltIcon.svg",
	"./calendarIcon.svg": "./src/assets/icons/calendarIcon.svg",
	"./calendarIconGreen.svg": "./src/assets/icons/calendarIconGreen.svg",
	"./calendarIconRed.svg": "./src/assets/icons/calendarIconRed.svg",
	"./calendarIconYellow.svg": "./src/assets/icons/calendarIconYellow.svg",
	"./caretDownIcon.svg": "./src/assets/icons/caretDownIcon.svg",
	"./checkClipIcon.svg": "./src/assets/icons/checkClipIcon.svg",
	"./checkIcon.svg": "./src/assets/icons/checkIcon.svg",
	"./checkSolidIcon.svg": "./src/assets/icons/checkSolidIcon.svg",
	"./checkboxIcon.svg": "./src/assets/icons/checkboxIcon.svg",
	"./checkboxIconChecked.svg": "./src/assets/icons/checkboxIconChecked.svg",
	"./circleExclamationIcon.svg": "./src/assets/icons/circleExclamationIcon.svg",
	"./circleInfoIcon.svg": "./src/assets/icons/circleInfoIcon.svg",
	"./circleNokIcon.svg": "./src/assets/icons/circleNokIcon.svg",
	"./circleOkIcon.svg": "./src/assets/icons/circleOkIcon.svg",
	"./clearIcon.svg": "./src/assets/icons/clearIcon.svg",
	"./clockIcon.svg": "./src/assets/icons/clockIcon.svg",
	"./closeMenu.svg": "./src/assets/icons/closeMenu.svg",
	"./copyIcon.svg": "./src/assets/icons/copyIcon.svg",
	"./dashboardIcon.svg": "./src/assets/icons/dashboardIcon.svg",
	"./deleteIcon.svg": "./src/assets/icons/deleteIcon.svg",
	"./departmentRelatedIcon.svg": "./src/assets/icons/departmentRelatedIcon.svg",
	"./diagnosticsIcon.svg": "./src/assets/icons/diagnosticsIcon.svg",
	"./doctorIcon.svg": "./src/assets/icons/doctorIcon.svg",
	"./documentsIcon.svg": "./src/assets/icons/documentsIcon.svg",
	"./editIcon.svg": "./src/assets/icons/editIcon.svg",
	"./examinationsIcon.svg": "./src/assets/icons/examinationsIcon.svg",
	"./expandMoreIcon.svg": "./src/assets/icons/expandMoreIcon.svg",
	"./filterIcon.svg": "./src/assets/icons/filterIcon.svg",
	"./filterIconMultiColor.svg": "./src/assets/icons/filterIconMultiColor.svg",
	"./flaskIcon.svg": "./src/assets/icons/flaskIcon.svg",
	"./globeIcon.svg": "./src/assets/icons/globeIcon.svg",
	"./globeSlashIcon.svg": "./src/assets/icons/globeSlashIcon.svg",
	"./haiStateColIcon.svg": "./src/assets/icons/haiStateColIcon.svg",
	"./haiStateNoIcon.svg": "./src/assets/icons/haiStateNoIcon.svg",
	"./haiStateRepIcon.svg": "./src/assets/icons/haiStateRepIcon.svg",
	"./haiStateWipIcon.svg": "./src/assets/icons/haiStateWipIcon.svg",
	"./haiStateYesIcon.svg": "./src/assets/icons/haiStateYesIcon.svg",
	"./haidiAddIcon.svg": "./src/assets/icons/haidiAddIcon.svg",
	"./haidiAtbAntibioticsIcon.svg": "./src/assets/icons/haidiAtbAntibioticsIcon.svg",
	"./haidiAtbLabsIcon.svg": "./src/assets/icons/haidiAtbLabsIcon.svg",
	"./haidiAtbPathogensIcon.svg": "./src/assets/icons/haidiAtbPathogensIcon.svg",
	"./haidiAuditLogIcon.svg": "./src/assets/icons/haidiAuditLogIcon.svg",
	"./haidiBedIcon.svg": "./src/assets/icons/haidiBedIcon.svg",
	"./haidiBedIconMultiColor.svg": "./src/assets/icons/haidiBedIconMultiColor.svg",
	"./haidiCloseIcon.svg": "./src/assets/icons/haidiCloseIcon.svg",
	"./haidiCloseIcon2.svg": "./src/assets/icons/haidiCloseIcon2.svg",
	"./haidiDashboardIcon.svg": "./src/assets/icons/haidiDashboardIcon.svg",
	"./haidiDashboardIconMultiColor.svg": "./src/assets/icons/haidiDashboardIconMultiColor.svg",
	"./haidiDeleteIcon.svg": "./src/assets/icons/haidiDeleteIcon.svg",
	"./haidiDepartmentReportIcon.svg": "./src/assets/icons/haidiDepartmentReportIcon.svg",
	"./haidiDocumentIconMultiColor.svg": "./src/assets/icons/haidiDocumentIconMultiColor.svg",
	"./haidiDocumentIconMultiColor2.svg": "./src/assets/icons/haidiDocumentIconMultiColor2.svg",
	"./haidiEditIcon.svg": "./src/assets/icons/haidiEditIcon.svg",
	"./haidiFirstPageIcon.svg": "./src/assets/icons/haidiFirstPageIcon.svg",
	"./haidiHaiIcon.svg": "./src/assets/icons/haidiHaiIcon.svg",
	"./haidiHaiListIcon.svg": "./src/assets/icons/haidiHaiListIcon.svg",
	"./haidiHospitalGroupReportIcon.svg": "./src/assets/icons/haidiHospitalGroupReportIcon.svg",
	"./haidiHospitalReportIcon.svg": "./src/assets/icons/haidiHospitalReportIcon.svg",
	"./haidiLabIcon.svg": "./src/assets/icons/haidiLabIcon.svg",
	"./haidiLabIconMultiColor.svg": "./src/assets/icons/haidiLabIconMultiColor.svg",
	"./haidiLabListIcon.svg": "./src/assets/icons/haidiLabListIcon.svg",
	"./haidiLastPageIcon.svg": "./src/assets/icons/haidiLastPageIcon.svg",
	"./haidiMedicineIcon.svg": "./src/assets/icons/haidiMedicineIcon.svg",
	"./haidiMonthlyOverviewIcon.svg": "./src/assets/icons/haidiMonthlyOverviewIcon.svg",
	"./haidiNextPageIcon.svg": "./src/assets/icons/haidiNextPageIcon.svg",
	"./haidiPathogensReportIcon.svg": "./src/assets/icons/haidiPathogensReportIcon.svg",
	"./haidiPatientListIcon.svg": "./src/assets/icons/haidiPatientListIcon.svg",
	"./haidiPipeMiddleIcon.svg": "./src/assets/icons/haidiPipeMiddleIcon.svg",
	"./haidiPipeVerticalIcon.svg": "./src/assets/icons/haidiPipeVerticalIcon.svg",
	"./haidiPrevPageIcon.svg": "./src/assets/icons/haidiPrevPageIcon.svg",
	"./haidiResetIcon.svg": "./src/assets/icons/haidiResetIcon.svg",
	"./haidiRightArrow.svg": "./src/assets/icons/haidiRightArrow.svg",
	"./haidiShowHideIconMultiColor.svg": "./src/assets/icons/haidiShowHideIconMultiColor.svg",
	"./haidiStethoscopeIcon.svg": "./src/assets/icons/haidiStethoscopeIcon.svg",
	"./haidiTimeIcon.svg": "./src/assets/icons/haidiTimeIcon.svg",
	"./haidiTransferIcon.svg": "./src/assets/icons/haidiTransferIcon.svg",
	"./haidiUserIcon.svg": "./src/assets/icons/haidiUserIcon.svg",
	"./haidiUserIconMultiColor.svg": "./src/assets/icons/haidiUserIconMultiColor.svg",
	"./haidiWarningIcon.svg": "./src/assets/icons/haidiWarningIcon.svg",
	"./haidiYearlyReportIcon.svg": "./src/assets/icons/haidiYearlyReportIcon.svg",
	"./haisByPathogenIcon.svg": "./src/assets/icons/haisByPathogenIcon.svg",
	"./haisByPathogenIconMultiColor.svg": "./src/assets/icons/haisByPathogenIconMultiColor.svg",
	"./heartCrossIcon.svg": "./src/assets/icons/heartCrossIcon.svg",
	"./hearthIcon.svg": "./src/assets/icons/hearthIcon.svg",
	"./hierarchyArrowIcon.svg": "./src/assets/icons/hierarchyArrowIcon.svg",
	"./hierarchyFileIcon.svg": "./src/assets/icons/hierarchyFileIcon.svg",
	"./hospitalIcon.svg": "./src/assets/icons/hospitalIcon.svg",
	"./hospitalUserIcon.svg": "./src/assets/icons/hospitalUserIcon.svg",
	"./hospitalizationDepartment.svg": "./src/assets/icons/hospitalizationDepartment.svg",
	"./hourglassHalfIcon.svg": "./src/assets/icons/hourglassHalfIcon.svg",
	"./infoIcon.svg": "./src/assets/icons/infoIcon.svg",
	"./laboratoryIcon.svg": "./src/assets/icons/laboratoryIcon.svg",
	"./laboratoryIconHaidi.svg": "./src/assets/icons/laboratoryIconHaidi.svg",
	"./laboratoryResultIcon.svg": "./src/assets/icons/laboratoryResultIcon.svg",
	"./leftArrowIcon.svg": "./src/assets/icons/leftArrowIcon.svg",
	"./leftEndArrowIcon.svg": "./src/assets/icons/leftEndArrowIcon.svg",
	"./listIcon.svg": "./src/assets/icons/listIcon.svg",
	"./listIconMultiColor.svg": "./src/assets/icons/listIconMultiColor.svg",
	"./listPlusIcon.svg": "./src/assets/icons/listPlusIcon.svg",
	"./lock.svg": "./src/assets/icons/lock.svg",
	"./lockIcon.svg": "./src/assets/icons/lockIcon.svg",
	"./lockOpen.svg": "./src/assets/icons/lockOpen.svg",
	"./lockSolidIcon.svg": "./src/assets/icons/lockSolidIcon.svg",
	"./logoutIcon.svg": "./src/assets/icons/logoutIcon.svg",
	"./logoutIconMultiColor.svg": "./src/assets/icons/logoutIconMultiColor.svg",
	"./maximize.svg": "./src/assets/icons/maximize.svg",
	"./maximizeIcon.svg": "./src/assets/icons/maximizeIcon.svg",
	"./medicalClipIcon.svg": "./src/assets/icons/medicalClipIcon.svg",
	"./medicalFileIcon.svg": "./src/assets/icons/medicalFileIcon.svg",
	"./medicationIcon.svg": "./src/assets/icons/medicationIcon.svg",
	"./menuDots2.svg": "./src/assets/icons/menuDots2.svg",
	"./merieHospitalizationsIcon.svg": "./src/assets/icons/merieHospitalizationsIcon.svg",
	"./merieSpikedExclamationIcon.svg": "./src/assets/icons/merieSpikedExclamationIcon.svg",
	"./minimize.svg": "./src/assets/icons/minimize.svg",
	"./numberFourIcon.svg": "./src/assets/icons/numberFourIcon.svg",
	"./numberOneIcon.svg": "./src/assets/icons/numberOneIcon.svg",
	"./numberThreeIcon.svg": "./src/assets/icons/numberThreeIcon.svg",
	"./numberTwoIcon.svg": "./src/assets/icons/numberTwoIcon.svg",
	"./numbersIcon.svg": "./src/assets/icons/numbersIcon.svg",
	"./openMenu.svg": "./src/assets/icons/openMenu.svg",
	"./orgSecurityIcon.svg": "./src/assets/icons/orgSecurityIcon.svg",
	"./patientClipIcon.svg": "./src/assets/icons/patientClipIcon.svg",
	"./penToSquare.svg": "./src/assets/icons/penToSquare.svg",
	"./phRecPublishIcon.svg": "./src/assets/icons/phRecPublishIcon.svg",
	"./pharmacoMessageIcon.svg": "./src/assets/icons/pharmacoMessageIcon.svg",
	"./pharmacotherapyEvaluationIcon.svg": "./src/assets/icons/pharmacotherapyEvaluationIcon.svg",
	"./pillOk.svg": "./src/assets/icons/pillOk.svg",
	"./pillsIcon.svg": "./src/assets/icons/pillsIcon.svg",
	"./plusClipIcon.svg": "./src/assets/icons/plusClipIcon.svg",
	"./plusIcon.svg": "./src/assets/icons/plusIcon.svg",
	"./rfGroupActiveIcon.svg": "./src/assets/icons/rfGroupActiveIcon.svg",
	"./rfGroupDeactivatedIcon.svg": "./src/assets/icons/rfGroupDeactivatedIcon.svg",
	"./rightArrowIcon.svg": "./src/assets/icons/rightArrowIcon.svg",
	"./rightEndArrowIcon.svg": "./src/assets/icons/rightEndArrowIcon.svg",
	"./riskFactorStarIcon.svg": "./src/assets/icons/riskFactorStarIcon.svg",
	"./rotateLeftIcon.svg": "./src/assets/icons/rotateLeftIcon.svg",
	"./savedFiltersIconMultiColor.svg": "./src/assets/icons/savedFiltersIconMultiColor.svg",
	"./scaleBalancedIcon.svg": "./src/assets/icons/scaleBalancedIcon.svg",
	"./scoreFrame.svg": "./src/assets/icons/scoreFrame.svg",
	"./searchIcon.svg": "./src/assets/icons/searchIcon.svg",
	"./selectedFiltersIconMultiColor.svg": "./src/assets/icons/selectedFiltersIconMultiColor.svg",
	"./settingsIcon.svg": "./src/assets/icons/settingsIcon.svg",
	"./settingsIconMultiColor.svg": "./src/assets/icons/settingsIconMultiColor.svg",
	"./slidersIcon.svg": "./src/assets/icons/slidersIcon.svg",
	"./stethoscopeIcon.svg": "./src/assets/icons/stethoscopeIcon.svg",
	"./tabAlertsIcon.svg": "./src/assets/icons/tabAlertsIcon.svg",
	"./tabPhRecommendationIcon.svg": "./src/assets/icons/tabPhRecommendationIcon.svg",
	"./tabRiskFactorsIcon.svg": "./src/assets/icons/tabRiskFactorsIcon.svg",
	"./tableIcon.svg": "./src/assets/icons/tableIcon.svg",
	"./threeDotsIcon.svg": "./src/assets/icons/threeDotsIcon.svg",
	"./timelineIcon.svg": "./src/assets/icons/timelineIcon.svg",
	"./transferIcon.svg": "./src/assets/icons/transferIcon.svg",
	"./trashCanIcon.svg": "./src/assets/icons/trashCanIcon.svg",
	"./trashIcon.svg": "./src/assets/icons/trashIcon.svg",
	"./triangleExclamationIcon.svg": "./src/assets/icons/triangleExclamationIcon.svg",
	"./unlockIcon.svg": "./src/assets/icons/unlockIcon.svg",
	"./userIcon.svg": "./src/assets/icons/userIcon.svg",
	"./userIconMultiColor.svg": "./src/assets/icons/userIconMultiColor.svg",
	"./warning.svg": "./src/assets/icons/warning.svg",
	"./xlsExportIcon.svg": "./src/assets/icons/xlsExportIcon.svg",
	"./xmarkIcon.svg": "./src/assets/icons/xmarkIcon.svg",
	"src/assets/icons/alertIcon.svg": "./src/assets/icons/alertIcon.svg",
	"src/assets/icons/allergyIcon.svg": "./src/assets/icons/allergyIcon.svg",
	"src/assets/icons/analytics1.svg": "./src/assets/icons/analytics1.svg",
	"src/assets/icons/analytics2.svg": "./src/assets/icons/analytics2.svg",
	"src/assets/icons/arrowDecreasingIcon.svg": "./src/assets/icons/arrowDecreasingIcon.svg",
	"src/assets/icons/arrowDownIcon.svg": "./src/assets/icons/arrowDownIcon.svg",
	"src/assets/icons/arrowIcon.svg": "./src/assets/icons/arrowIcon.svg",
	"src/assets/icons/arrowIncreasingIcon.svg": "./src/assets/icons/arrowIncreasingIcon.svg",
	"src/assets/icons/arrowLeftIcon.svg": "./src/assets/icons/arrowLeftIcon.svg",
	"src/assets/icons/arrowRightIcon.svg": "./src/assets/icons/arrowRightIcon.svg",
	"src/assets/icons/bacteriumIcon.svg": "./src/assets/icons/bacteriumIcon.svg",
	"src/assets/icons/badgeCheckIcon.svg": "./src/assets/icons/badgeCheckIcon.svg",
	"src/assets/icons/badgeExclamationIcon.svg": "./src/assets/icons/badgeExclamationIcon.svg",
	"src/assets/icons/barChartIconMultiColor.svg": "./src/assets/icons/barChartIconMultiColor.svg",
	"src/assets/icons/bedIcon.svg": "./src/assets/icons/bedIcon.svg",
	"src/assets/icons/bellIcon.svg": "./src/assets/icons/bellIcon.svg",
	"src/assets/icons/bellIconHalfColor.svg": "./src/assets/icons/bellIconHalfColor.svg",
	"src/assets/icons/bellSlashIcon.svg": "./src/assets/icons/bellSlashIcon.svg",
	"src/assets/icons/boltIcon.svg": "./src/assets/icons/boltIcon.svg",
	"src/assets/icons/calendarIcon.svg": "./src/assets/icons/calendarIcon.svg",
	"src/assets/icons/calendarIconGreen.svg": "./src/assets/icons/calendarIconGreen.svg",
	"src/assets/icons/calendarIconRed.svg": "./src/assets/icons/calendarIconRed.svg",
	"src/assets/icons/calendarIconYellow.svg": "./src/assets/icons/calendarIconYellow.svg",
	"src/assets/icons/caretDownIcon.svg": "./src/assets/icons/caretDownIcon.svg",
	"src/assets/icons/checkClipIcon.svg": "./src/assets/icons/checkClipIcon.svg",
	"src/assets/icons/checkIcon.svg": "./src/assets/icons/checkIcon.svg",
	"src/assets/icons/checkSolidIcon.svg": "./src/assets/icons/checkSolidIcon.svg",
	"src/assets/icons/checkboxIcon.svg": "./src/assets/icons/checkboxIcon.svg",
	"src/assets/icons/checkboxIconChecked.svg": "./src/assets/icons/checkboxIconChecked.svg",
	"src/assets/icons/circleExclamationIcon.svg": "./src/assets/icons/circleExclamationIcon.svg",
	"src/assets/icons/circleInfoIcon.svg": "./src/assets/icons/circleInfoIcon.svg",
	"src/assets/icons/circleNokIcon.svg": "./src/assets/icons/circleNokIcon.svg",
	"src/assets/icons/circleOkIcon.svg": "./src/assets/icons/circleOkIcon.svg",
	"src/assets/icons/clearIcon.svg": "./src/assets/icons/clearIcon.svg",
	"src/assets/icons/clockIcon.svg": "./src/assets/icons/clockIcon.svg",
	"src/assets/icons/closeMenu.svg": "./src/assets/icons/closeMenu.svg",
	"src/assets/icons/copyIcon.svg": "./src/assets/icons/copyIcon.svg",
	"src/assets/icons/dashboardIcon.svg": "./src/assets/icons/dashboardIcon.svg",
	"src/assets/icons/deleteIcon.svg": "./src/assets/icons/deleteIcon.svg",
	"src/assets/icons/departmentRelatedIcon.svg": "./src/assets/icons/departmentRelatedIcon.svg",
	"src/assets/icons/diagnosticsIcon.svg": "./src/assets/icons/diagnosticsIcon.svg",
	"src/assets/icons/doctorIcon.svg": "./src/assets/icons/doctorIcon.svg",
	"src/assets/icons/documentsIcon.svg": "./src/assets/icons/documentsIcon.svg",
	"src/assets/icons/editIcon.svg": "./src/assets/icons/editIcon.svg",
	"src/assets/icons/examinationsIcon.svg": "./src/assets/icons/examinationsIcon.svg",
	"src/assets/icons/expandMoreIcon.svg": "./src/assets/icons/expandMoreIcon.svg",
	"src/assets/icons/filterIcon.svg": "./src/assets/icons/filterIcon.svg",
	"src/assets/icons/filterIconMultiColor.svg": "./src/assets/icons/filterIconMultiColor.svg",
	"src/assets/icons/flaskIcon.svg": "./src/assets/icons/flaskIcon.svg",
	"src/assets/icons/globeIcon.svg": "./src/assets/icons/globeIcon.svg",
	"src/assets/icons/globeSlashIcon.svg": "./src/assets/icons/globeSlashIcon.svg",
	"src/assets/icons/haiStateColIcon.svg": "./src/assets/icons/haiStateColIcon.svg",
	"src/assets/icons/haiStateNoIcon.svg": "./src/assets/icons/haiStateNoIcon.svg",
	"src/assets/icons/haiStateRepIcon.svg": "./src/assets/icons/haiStateRepIcon.svg",
	"src/assets/icons/haiStateWipIcon.svg": "./src/assets/icons/haiStateWipIcon.svg",
	"src/assets/icons/haiStateYesIcon.svg": "./src/assets/icons/haiStateYesIcon.svg",
	"src/assets/icons/haidiAddIcon.svg": "./src/assets/icons/haidiAddIcon.svg",
	"src/assets/icons/haidiAtbAntibioticsIcon.svg": "./src/assets/icons/haidiAtbAntibioticsIcon.svg",
	"src/assets/icons/haidiAtbLabsIcon.svg": "./src/assets/icons/haidiAtbLabsIcon.svg",
	"src/assets/icons/haidiAtbPathogensIcon.svg": "./src/assets/icons/haidiAtbPathogensIcon.svg",
	"src/assets/icons/haidiAuditLogIcon.svg": "./src/assets/icons/haidiAuditLogIcon.svg",
	"src/assets/icons/haidiBedIcon.svg": "./src/assets/icons/haidiBedIcon.svg",
	"src/assets/icons/haidiBedIconMultiColor.svg": "./src/assets/icons/haidiBedIconMultiColor.svg",
	"src/assets/icons/haidiCloseIcon.svg": "./src/assets/icons/haidiCloseIcon.svg",
	"src/assets/icons/haidiCloseIcon2.svg": "./src/assets/icons/haidiCloseIcon2.svg",
	"src/assets/icons/haidiDashboardIcon.svg": "./src/assets/icons/haidiDashboardIcon.svg",
	"src/assets/icons/haidiDashboardIconMultiColor.svg": "./src/assets/icons/haidiDashboardIconMultiColor.svg",
	"src/assets/icons/haidiDeleteIcon.svg": "./src/assets/icons/haidiDeleteIcon.svg",
	"src/assets/icons/haidiDepartmentReportIcon.svg": "./src/assets/icons/haidiDepartmentReportIcon.svg",
	"src/assets/icons/haidiDocumentIconMultiColor.svg": "./src/assets/icons/haidiDocumentIconMultiColor.svg",
	"src/assets/icons/haidiDocumentIconMultiColor2.svg": "./src/assets/icons/haidiDocumentIconMultiColor2.svg",
	"src/assets/icons/haidiEditIcon.svg": "./src/assets/icons/haidiEditIcon.svg",
	"src/assets/icons/haidiFirstPageIcon.svg": "./src/assets/icons/haidiFirstPageIcon.svg",
	"src/assets/icons/haidiHaiIcon.svg": "./src/assets/icons/haidiHaiIcon.svg",
	"src/assets/icons/haidiHaiListIcon.svg": "./src/assets/icons/haidiHaiListIcon.svg",
	"src/assets/icons/haidiHospitalGroupReportIcon.svg": "./src/assets/icons/haidiHospitalGroupReportIcon.svg",
	"src/assets/icons/haidiHospitalReportIcon.svg": "./src/assets/icons/haidiHospitalReportIcon.svg",
	"src/assets/icons/haidiLabIcon.svg": "./src/assets/icons/haidiLabIcon.svg",
	"src/assets/icons/haidiLabIconMultiColor.svg": "./src/assets/icons/haidiLabIconMultiColor.svg",
	"src/assets/icons/haidiLabListIcon.svg": "./src/assets/icons/haidiLabListIcon.svg",
	"src/assets/icons/haidiLastPageIcon.svg": "./src/assets/icons/haidiLastPageIcon.svg",
	"src/assets/icons/haidiMedicineIcon.svg": "./src/assets/icons/haidiMedicineIcon.svg",
	"src/assets/icons/haidiMonthlyOverviewIcon.svg": "./src/assets/icons/haidiMonthlyOverviewIcon.svg",
	"src/assets/icons/haidiNextPageIcon.svg": "./src/assets/icons/haidiNextPageIcon.svg",
	"src/assets/icons/haidiPathogensReportIcon.svg": "./src/assets/icons/haidiPathogensReportIcon.svg",
	"src/assets/icons/haidiPatientListIcon.svg": "./src/assets/icons/haidiPatientListIcon.svg",
	"src/assets/icons/haidiPipeMiddleIcon.svg": "./src/assets/icons/haidiPipeMiddleIcon.svg",
	"src/assets/icons/haidiPipeVerticalIcon.svg": "./src/assets/icons/haidiPipeVerticalIcon.svg",
	"src/assets/icons/haidiPrevPageIcon.svg": "./src/assets/icons/haidiPrevPageIcon.svg",
	"src/assets/icons/haidiResetIcon.svg": "./src/assets/icons/haidiResetIcon.svg",
	"src/assets/icons/haidiRightArrow.svg": "./src/assets/icons/haidiRightArrow.svg",
	"src/assets/icons/haidiShowHideIconMultiColor.svg": "./src/assets/icons/haidiShowHideIconMultiColor.svg",
	"src/assets/icons/haidiStethoscopeIcon.svg": "./src/assets/icons/haidiStethoscopeIcon.svg",
	"src/assets/icons/haidiTimeIcon.svg": "./src/assets/icons/haidiTimeIcon.svg",
	"src/assets/icons/haidiTransferIcon.svg": "./src/assets/icons/haidiTransferIcon.svg",
	"src/assets/icons/haidiUserIcon.svg": "./src/assets/icons/haidiUserIcon.svg",
	"src/assets/icons/haidiUserIconMultiColor.svg": "./src/assets/icons/haidiUserIconMultiColor.svg",
	"src/assets/icons/haidiWarningIcon.svg": "./src/assets/icons/haidiWarningIcon.svg",
	"src/assets/icons/haidiYearlyReportIcon.svg": "./src/assets/icons/haidiYearlyReportIcon.svg",
	"src/assets/icons/haisByPathogenIcon.svg": "./src/assets/icons/haisByPathogenIcon.svg",
	"src/assets/icons/haisByPathogenIconMultiColor.svg": "./src/assets/icons/haisByPathogenIconMultiColor.svg",
	"src/assets/icons/heartCrossIcon.svg": "./src/assets/icons/heartCrossIcon.svg",
	"src/assets/icons/hearthIcon.svg": "./src/assets/icons/hearthIcon.svg",
	"src/assets/icons/hierarchyArrowIcon.svg": "./src/assets/icons/hierarchyArrowIcon.svg",
	"src/assets/icons/hierarchyFileIcon.svg": "./src/assets/icons/hierarchyFileIcon.svg",
	"src/assets/icons/hospitalIcon.svg": "./src/assets/icons/hospitalIcon.svg",
	"src/assets/icons/hospitalUserIcon.svg": "./src/assets/icons/hospitalUserIcon.svg",
	"src/assets/icons/hospitalizationDepartment.svg": "./src/assets/icons/hospitalizationDepartment.svg",
	"src/assets/icons/hourglassHalfIcon.svg": "./src/assets/icons/hourglassHalfIcon.svg",
	"src/assets/icons/infoIcon.svg": "./src/assets/icons/infoIcon.svg",
	"src/assets/icons/laboratoryIcon.svg": "./src/assets/icons/laboratoryIcon.svg",
	"src/assets/icons/laboratoryIconHaidi.svg": "./src/assets/icons/laboratoryIconHaidi.svg",
	"src/assets/icons/laboratoryResultIcon.svg": "./src/assets/icons/laboratoryResultIcon.svg",
	"src/assets/icons/leftArrowIcon.svg": "./src/assets/icons/leftArrowIcon.svg",
	"src/assets/icons/leftEndArrowIcon.svg": "./src/assets/icons/leftEndArrowIcon.svg",
	"src/assets/icons/listIcon.svg": "./src/assets/icons/listIcon.svg",
	"src/assets/icons/listIconMultiColor.svg": "./src/assets/icons/listIconMultiColor.svg",
	"src/assets/icons/listPlusIcon.svg": "./src/assets/icons/listPlusIcon.svg",
	"src/assets/icons/lock.svg": "./src/assets/icons/lock.svg",
	"src/assets/icons/lockIcon.svg": "./src/assets/icons/lockIcon.svg",
	"src/assets/icons/lockOpen.svg": "./src/assets/icons/lockOpen.svg",
	"src/assets/icons/lockSolidIcon.svg": "./src/assets/icons/lockSolidIcon.svg",
	"src/assets/icons/logoutIcon.svg": "./src/assets/icons/logoutIcon.svg",
	"src/assets/icons/logoutIconMultiColor.svg": "./src/assets/icons/logoutIconMultiColor.svg",
	"src/assets/icons/maximize.svg": "./src/assets/icons/maximize.svg",
	"src/assets/icons/maximizeIcon.svg": "./src/assets/icons/maximizeIcon.svg",
	"src/assets/icons/medicalClipIcon.svg": "./src/assets/icons/medicalClipIcon.svg",
	"src/assets/icons/medicalFileIcon.svg": "./src/assets/icons/medicalFileIcon.svg",
	"src/assets/icons/medicationIcon.svg": "./src/assets/icons/medicationIcon.svg",
	"src/assets/icons/menuDots2.svg": "./src/assets/icons/menuDots2.svg",
	"src/assets/icons/merieHospitalizationsIcon.svg": "./src/assets/icons/merieHospitalizationsIcon.svg",
	"src/assets/icons/merieSpikedExclamationIcon.svg": "./src/assets/icons/merieSpikedExclamationIcon.svg",
	"src/assets/icons/minimize.svg": "./src/assets/icons/minimize.svg",
	"src/assets/icons/numberFourIcon.svg": "./src/assets/icons/numberFourIcon.svg",
	"src/assets/icons/numberOneIcon.svg": "./src/assets/icons/numberOneIcon.svg",
	"src/assets/icons/numberThreeIcon.svg": "./src/assets/icons/numberThreeIcon.svg",
	"src/assets/icons/numberTwoIcon.svg": "./src/assets/icons/numberTwoIcon.svg",
	"src/assets/icons/numbersIcon.svg": "./src/assets/icons/numbersIcon.svg",
	"src/assets/icons/openMenu.svg": "./src/assets/icons/openMenu.svg",
	"src/assets/icons/orgSecurityIcon.svg": "./src/assets/icons/orgSecurityIcon.svg",
	"src/assets/icons/patientClipIcon.svg": "./src/assets/icons/patientClipIcon.svg",
	"src/assets/icons/penToSquare.svg": "./src/assets/icons/penToSquare.svg",
	"src/assets/icons/phRecPublishIcon.svg": "./src/assets/icons/phRecPublishIcon.svg",
	"src/assets/icons/pharmacoMessageIcon.svg": "./src/assets/icons/pharmacoMessageIcon.svg",
	"src/assets/icons/pharmacotherapyEvaluationIcon.svg": "./src/assets/icons/pharmacotherapyEvaluationIcon.svg",
	"src/assets/icons/pillOk.svg": "./src/assets/icons/pillOk.svg",
	"src/assets/icons/pillsIcon.svg": "./src/assets/icons/pillsIcon.svg",
	"src/assets/icons/plusClipIcon.svg": "./src/assets/icons/plusClipIcon.svg",
	"src/assets/icons/plusIcon.svg": "./src/assets/icons/plusIcon.svg",
	"src/assets/icons/rfGroupActiveIcon.svg": "./src/assets/icons/rfGroupActiveIcon.svg",
	"src/assets/icons/rfGroupDeactivatedIcon.svg": "./src/assets/icons/rfGroupDeactivatedIcon.svg",
	"src/assets/icons/rightArrowIcon.svg": "./src/assets/icons/rightArrowIcon.svg",
	"src/assets/icons/rightEndArrowIcon.svg": "./src/assets/icons/rightEndArrowIcon.svg",
	"src/assets/icons/riskFactorStarIcon.svg": "./src/assets/icons/riskFactorStarIcon.svg",
	"src/assets/icons/rotateLeftIcon.svg": "./src/assets/icons/rotateLeftIcon.svg",
	"src/assets/icons/savedFiltersIconMultiColor.svg": "./src/assets/icons/savedFiltersIconMultiColor.svg",
	"src/assets/icons/scaleBalancedIcon.svg": "./src/assets/icons/scaleBalancedIcon.svg",
	"src/assets/icons/scoreFrame.svg": "./src/assets/icons/scoreFrame.svg",
	"src/assets/icons/searchIcon.svg": "./src/assets/icons/searchIcon.svg",
	"src/assets/icons/selectedFiltersIconMultiColor.svg": "./src/assets/icons/selectedFiltersIconMultiColor.svg",
	"src/assets/icons/settingsIcon.svg": "./src/assets/icons/settingsIcon.svg",
	"src/assets/icons/settingsIconMultiColor.svg": "./src/assets/icons/settingsIconMultiColor.svg",
	"src/assets/icons/slidersIcon.svg": "./src/assets/icons/slidersIcon.svg",
	"src/assets/icons/stethoscopeIcon.svg": "./src/assets/icons/stethoscopeIcon.svg",
	"src/assets/icons/tabAlertsIcon.svg": "./src/assets/icons/tabAlertsIcon.svg",
	"src/assets/icons/tabPhRecommendationIcon.svg": "./src/assets/icons/tabPhRecommendationIcon.svg",
	"src/assets/icons/tabRiskFactorsIcon.svg": "./src/assets/icons/tabRiskFactorsIcon.svg",
	"src/assets/icons/tableIcon.svg": "./src/assets/icons/tableIcon.svg",
	"src/assets/icons/threeDotsIcon.svg": "./src/assets/icons/threeDotsIcon.svg",
	"src/assets/icons/timelineIcon.svg": "./src/assets/icons/timelineIcon.svg",
	"src/assets/icons/transferIcon.svg": "./src/assets/icons/transferIcon.svg",
	"src/assets/icons/trashCanIcon.svg": "./src/assets/icons/trashCanIcon.svg",
	"src/assets/icons/trashIcon.svg": "./src/assets/icons/trashIcon.svg",
	"src/assets/icons/triangleExclamationIcon.svg": "./src/assets/icons/triangleExclamationIcon.svg",
	"src/assets/icons/unlockIcon.svg": "./src/assets/icons/unlockIcon.svg",
	"src/assets/icons/userIcon.svg": "./src/assets/icons/userIcon.svg",
	"src/assets/icons/userIconMultiColor.svg": "./src/assets/icons/userIconMultiColor.svg",
	"src/assets/icons/warning.svg": "./src/assets/icons/warning.svg",
	"src/assets/icons/xlsExportIcon.svg": "./src/assets/icons/xlsExportIcon.svg",
	"src/assets/icons/xmarkIcon.svg": "./src/assets/icons/xmarkIcon.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons sync \\.svg$";